module.exports = __webpack_public_path__ + "img/WP2023-Icon-Platforms.6d92a595.svg";